import React from 'react'

const Dollar = (props) => {
  return (
    <svg width="14" height="14" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.9444 5.43194C12.9444 3.90463 11.0292 2.6665 8.66664 2.6665C6.30408 2.6665 4.38886 3.90463 4.38886 5.43194C4.38886 6.95924 5.55552 7.8023 8.66664 7.8023C11.7778 7.8023 13.3333 8.59244 13.3333 10.5678C13.3333 12.543 11.244 13.3332 8.66664 13.3332C6.08931 13.3332 3.99997 12.095 3.99997 10.5678" stroke={props.color ? props.color : '#141B34'} strokeWidth="1.5" strokeLinecap="round"/>
<path d="M8.66663 1.3335V14.6668" stroke={props.color ? props.color : '#141B34'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  )
}

export default Dollar
